<template lang="pug">
.admin-file
  v-card
    v-card-title 幹部文件
    v-card-text
      template(v-if="!id")
        v-list(v-if="articles")
          v-list-tile(
            v-for="article in articles"
            :key="article.id"
            @click="$router.push({ name: 'admin-file', params: { id: article.id }})")
            v-list-tile-content
              v-list-tile-title {{ article.data.title }}
        page-loading(v-else)
      template(v-else)
        v-btn(color="warning" @click="$router.push({ name: 'admin-file' })") 返回
        template(v-if="current")
          .display-1.py-2 標題
          div {{ current.data.title }}
          .display-1.py-2 內文
          div(v-html="current.data.content")
          .display-1 檔案
          v-list
            v-list-tile(v-for="file in current.data.files" :key="file.src" @click="download(file.url)")
              v-list-tile-action
                v-icon cloud_download
              v-list-tile-title {{ file.title }}
          .display-1 照片
          v-container
            v-layout(wrap)
              v-flex.pa-2(v-for="(photo, index) in current.data.photos" xs12 sm4 md3)
                v-card(flat)
                  v-img(:src="photo.src || ''")   
</template>
<script>
import { db } from "@/firebase";
import PageLoading from "@/components/core/PageLoading.vue";
import orderBy from "lodash/orderBy";

export default {
  name: "AdminFile",
  components: {
    PageLoading
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      articles: []
    };
  },
  computed: {
    current() {
      return this.articles.find(o => o.id === this.id);
    }
  },
  methods: {
    download(URL) {
      window.open(URL);
    }
  },
  async mounted() {
    const snap = await db
      .collection("articles")
      .where("type", "==", "official_doc")
      .get();
    const list = [];
    snap.forEach(doc => {
      list.push({ id: doc.id, data: doc.data() });
    });
    this.articles = orderBy(list, ["data.title"], ["desc"]);
  }
};
</script>
